"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var storeApi = _interopRequireWildcard(require("@/api/store"));
var jdStoreApi = _interopRequireWildcard(require("@/api/jdStoreApi.js"));
var samStoreApi = _interopRequireWildcard(require("@/api/samStoreApi.js"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  props: {
    pageType: {
      type: Number,
      default: 0
    },
    // 活动商品等场景：仅自营 + 仅指定SKU
    onlySelfSku: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: false,
      pram: {},
      editIdx: 0,
      tagOption: [],
      jdCateIdsOption: [],
      // 京东商品分类
      cateIdsOption: [],
      // 商品分类
      brandOption: [],
      userType: null,
      GOODS_TYPE_MAP: [{
        name: '自营商品',
        key: 1
      }, {
        name: '福司令商品',
        key: 2
      }, {
        name: '自营+福司令',
        key: 4
      }, {
        name: '蛋糕商品',
        key: 3
      }, {
        name: '商户入驻商品',
        key: 18
      }, {
        name: '福豆系统充值',
        key: 110
      }, {
        name: '来一票京东',
        key: 80
      }, {
        name: '来一票山姆',
        key: 81
      }],
      LYP_SORT_OPTIONS: [{
        key: 1,
        label: '销量降序'
      }, {
        key: 2,
        label: '价格升序（会出现价格过低商品，且个别价格低商品无法下单）'
      }, {
        key: 3,
        label: '价格降序'
      }, {
        key: 4,
        label: '评论数降序'
      }, {
        key: 5,
        label: '上架时间降序'
      }, {
        key: 6,
        label: '15天销售额降序'
      }]
    };
  },
  computed: {
    isHomePage: function isHomePage() {
      return Number(this.pageType) === 1;
    },
    isLypSource: function isLypSource() {
      return [80, 81].includes(this.pram && this.pram.sourceType);
    },
    isMiniProgramCustomer: function isMiniProgramCustomer() {
      return Number(this.userType) === 5;
    },
    filteredGoodsTypeMap: function filteredGoodsTypeMap() {
      var sourceList = this.GOODS_TYPE_MAP;
      if (this.onlySelfSku) {
        return sourceList.filter(function (item) {
          return item.key === 1;
        });
      }
      if (this.isHomePage) {
        sourceList = sourceList.filter(function (item) {
          return ![80, 81].includes(item.key);
        });
      }
      if (this.isMiniProgramCustomer) {
        return sourceList.filter(function (item) {
          return item.key === 18;
        });
      }
      if (this.userType === 1) {
        return sourceList;
      }
      return sourceList.filter(function (item) {
        return item.key === 1;
      });
    }
  },
  mounted: function mounted() {
    // 获取用户类型
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
  },
  methods: {
    throttle: _throttle.default,
    openInit: function openInit(editIdx) {
      var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      console.log(row);
      this.searchBrand('');
      this.searchTag((row === null || row === void 0 ? void 0 : row.sourceType) || 1);
      var rowGoodsType = row.goodsType != null ? row.goodsType : row.type;
      this.pram = _objectSpread(_objectSpread({
        isCheap: 1
      }, row), {}, {
        goodsType: rowGoodsType
      });
      if (this.isHomePage && [80, 81].includes(Number(this.pram.sourceType))) {
        this.$set(this.pram, 'sourceType', 1);
        this.$delete(this.pram, 'lypSortType');
      }
      if ([80, 81].includes(Number(this.pram.sourceType))) {
        var st = Number(this.pram.lypSortType);
        this.$set(this.pram, 'lypSortType', [1, 2, 3, 4, 5, 6].includes(st) ? st : 1);
      } else {
        this.$delete(this.pram, 'lypSortType');
      }

      // 仅在非80/81且未配置绑定方式时给默认值，避免丢失80/81回显
      if (!rowGoodsType && ![80, 81].includes(Number(this.pram.sourceType))) {
        this.pram.goodsType = this.isMiniProgramCustomer ? 3 : 5;
      }
      if (this.isMiniProgramCustomer) {
        this.pram.sourceType = 18;
        this.pram.goodsType = 3;
      } else if (this.userType !== 1) {
        this.pram.sourceType = 1;
      }

      // 活动商品：仅自营 + 仅指定SKU输入
      if (this.onlySelfSku) {
        this.pram.sourceType = 1;
        this.pram.goodsType = 3;
        this.$delete(this.pram, 'lypSortType');
      }
      this.getCate(this.pram.sourceType);
      this.editIdx = editIdx;
      this.visible = true;
    },
    _handerGoodsStr: function _handerGoodsStr() {
      var _showCateId$map;
      if (this.isLypSource) {
        return _objectSpread(_objectSpread({}, this.pram), {}, {
          type: this.pram.goodsType,
          goodsType: null,
          goodsStr: null,
          isCheap: null
        });
      }
      var _ref = this.pram || {},
        skuId = _ref.skuId,
        _ref$labelId = _ref.labelId,
        labelId = _ref$labelId === void 0 ? [] : _ref$labelId,
        _ref$showCateId = _ref.showCateId,
        showCateId = _ref$showCateId === void 0 ? [] : _ref$showCateId,
        _ref$brandIds = _ref.brandIds,
        brandIds = _ref$brandIds === void 0 ? [] : _ref$brandIds,
        goodsType = _ref.goodsType;
      var strMap = {
        1: (showCateId === null || showCateId === void 0 ? void 0 : (_showCateId$map = showCateId.map(function (j) {
          return j === null || j === void 0 ? void 0 : j.at(-1);
        })) === null || _showCateId$map === void 0 ? void 0 : _showCateId$map.join(',')) || null,
        2: (labelId === null || labelId === void 0 ? void 0 : labelId.join(',')) || null,
        3: skuId,
        4: (brandIds === null || brandIds === void 0 ? void 0 : brandIds.join(',')) || null
      };
      return _objectSpread(_objectSpread({}, this.pram), {}, {
        goodsStr: (strMap === null || strMap === void 0 ? void 0 : strMap[goodsType]) || null
      });
    },
    saveEdit: function saveEdit() {
      var _this = this;
      // console.log(this.editIdx, this._handerGoodsStr(this.pram))
      if (this.pram.sourceType == 3) {
        this.pram.isCheap = 0;
      }
      this.$refs.pram.validate(function (ok) {
        if (!ok) return;
        _this.$emit('saveEdit', _this.editIdx, _this._handerGoodsStr(_this.pram));
        _this.visible = false;
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    changeSourceType: function changeSourceType() {
      var _this$pram, _this$pram2, _this$pram3;
      var _ref2 = this.pram || {},
        sourceType = _ref2.sourceType,
        goodsType = _ref2.goodsType;
      if (this.isMiniProgramCustomer) {
        this.$set(this.pram, 'sourceType', 18);
        this.$set(this.pram, 'goodsType', 3);
        return;
      }
      if (this.isHomePage && [80, 81].includes(sourceType)) {
        this.$set(this.pram, 'sourceType', 1);
        sourceType = 1;
      }
      (_this$pram = this.pram) === null || _this$pram === void 0 ? true : delete _this$pram.skuId;
      (_this$pram2 = this.pram) === null || _this$pram2 === void 0 ? true : delete _this$pram2.labelId;
      (_this$pram3 = this.pram) === null || _this$pram3 === void 0 ? true : delete _this$pram3.showCateId;
      this.searchTag(sourceType);
      this.getCate(sourceType);
      if (![80, 81].includes(sourceType)) {
        this.$delete(this.pram, 'lypSortType');
      } else {
        var st = Number(this.pram.lypSortType);
        if (![1, 2, 3, 4, 5, 6].includes(st)) {
          this.$set(this.pram, 'lypSortType', 1);
        }
      }
      // 来一票京东/山姆：只允许 指定分类/指定SKU
      if ([80, 81].includes(sourceType) && ![1, 3].includes(goodsType)) {
        this.pram.goodsType = 1;
      }
      if (sourceType == 2 && goodsType == 1) {
        var _this$pram4;
        (_this$pram4 = this.pram) === null || _this$pram4 === void 0 ? true : delete _this$pram4.goodsType;
      }
      ;
    },
    getCate: function getCate(sourceType) {
      var _this2 = this;
      this.jdCateIdsOption = [];
      categoryApi.jdCateLists().then(function (res) {
        _this2.jdCateIdsOption = res;
      });
      this.cateIdsOption = [];
      // 来一票京东/山姆：指定分类时 cateIdsOption 用 mall/category/list(status=1)
      if ([80, 81].includes(sourceType)) {
        var req = sourceType === 80 ? jdStoreApi.getJdCategoryList : samStoreApi.getSamCategoryList;
        req({
          status: 1
        }).then(function (res) {
          _this2.cateIdsOption = Array.isArray(res) ? res : res && res.data || [];
        }).catch(function () {
          _this2.cateIdsOption = [];
        });
        return;
      }
      storeApi.categoryApi({
        status: -1,
        type: 8
      }).then(function (res) {
        _this2.cateIdsOption = _this2.addDisabled(res);
      });
    },
    searchTag: function searchTag(type) {
      var _this3 = this;
      this.tagOption = [];
      storeApi.getLabelApi({
        type: type
      }).then(function (res) {
        _this3.tagOption = res || [];
      });
    },
    addDisabled: function addDisabled() {
      var _this4 = this;
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var list = [];
      arr && arr.length && arr.forEach(function (e, index) {
        var e_new = _objectSpread(_objectSpread({}, e), {}, {
          disabled: !e.status
        });
        if (e.child) {
          var childList = _this4.addDisabled(e.child);
          e_new = _objectSpread(_objectSpread({}, e_new), {}, {
            child: childList
          });
        }
        list.push(e_new);
      });
      return list;
    },
    searchBrand: function searchBrand() {
      var _this5 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      dangaoActApi.getAllDangaoBrand(keyword).then(function (res) {
        _this5.brandOption = res && res.length && res.map(function (item) {
          var _ref3 = item || {},
            brandId = _ref3.brandId,
            brandName = _ref3.brandName,
            source = _ref3.source;
          return {
            id: brandId,
            brandName: brandName,
            brandStr: "".concat(brandName, "--ID").concat(brandId, "\u3010").concat(source, "\u3011")
          };
        }) || [];
      });
    },
    // 搜索品牌
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this6 = this;
      this.throttle(function () {
        _this6.searchBrand(data);
      }, 300)();
    }
  }
};